import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal,NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bid-secondary-fume-confirm',
  templateUrl: './bid-secondary-fume-confirm.component.html',
  styleUrls: ['./bid-secondary-fume-confirm.component.scss']
})
export class BidSecondaryFumeConfirmComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {

  }
  	closeModal() {
		this.activeModal.close(false);
  	}

  	setFumeCode(event){
  		this.activeModal.close(true);
  	}

}
